import React from "react";
import styles from "../styles/rightsTile.module.css";
import TileType from "../constants/TileType";
import { useNavigate } from "react-router-dom";
import { animated } from "react-spring";

const RightsTile = ({
  rightData,
  tileType,
  fetchSubrights,
  fetchLearnMores,
  setSelectedRightCategory,
  setSelectedSubright,
  animateStyle,
}) => {
  const navigate = useNavigate();

  const onPressShowSubsection = () => {
    if (tileType === TileType.RIGHT) {
      setSelectedRightCategory(rightData);
      fetchSubrights(rightData.id);
    } else if (tileType === TileType.SUBRIGHT) {
      setSelectedSubright(rightData);
      fetchLearnMores(rightData.id);
    }
  };

  const onPressMoreEdit = () => {
    if (tileType === TileType.RIGHT) {
      navigate("/rights/info", {
        state: { rightCategory: rightData, editMode: true },
      });
    } else if (tileType === TileType.SUBRIGHT) {
      navigate("/rights/subright", {
        state: { subright: rightData, editMode: true },
      });
    } else if (tileType === TileType.LEARNMORE) {
      navigate("/rights/learnMore", {
        state: { learnMore: rightData, editMode: true },
      });
    }
  };

  const descriptionPresentation = () => {
    if (tileType === TileType.LEARNMORE) {
      return "";
    }
    const descriptionStr = rightData.description;
    return descriptionStr.length > 120
      ? `${descriptionStr.substring(0, 110)}...`
      : descriptionStr;
  };

  return (
    <animated.div style={animateStyle} className={styles.container}>
      <p className={styles.title}>{rightData.title}</p>
      {tileType !== TileType.LEARNMORE ? (
        <p className={styles.description}>{descriptionPresentation()}</p>
      ) : null}
      <div className={styles.buttonsContainer}>
        <div className={styles.editButton} onClick={onPressMoreEdit}>
          More / Edit
        </div>
        {tileType !== TileType.LEARNMORE ? (
          <div
            className={styles.subsectionButton}
            onClick={onPressShowSubsection}
          >
            Show Subsection
          </div>
        ) : null}
      </div>
    </animated.div>
  );
};

export default RightsTile;
